import React from 'react';

import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { BUTTON_THEME_FULL_GREEN } from '../../../../shared/common/Button/themes';
import { ProductGroupStatistics } from '../ProductGroupStatistics';
import { MappedProductGroup, UsageStatisticsOut } from '../../../../store/api';
import { useTranslation } from 'react-i18next';
import { ButtonIconTextWidthAuto } from '../../../../shared/common/Button/ButtonIconTextWidthAuto';
import {
    MATERIAL_ICON_ARROW_DOWN,
    MATERIAL_ICON_ARROW_UP,
    MATERIAL_ICON_EDIT
} from '../../../../shared/common/Button/Icon';

const StStatisticsWithActions = styled.div`
    display: flex;
    align-items: center;

    & > * {
        margin-left: 5px;
    }
`;

interface Props {
    usageStatistics: UsageStatisticsOut;
    expirationInDays?: number;
    libraryManagedSlotNumber: number;
    lastEditedEpochMillis?: number;
    moveDown: (slotId: any) => void;
    moveUp: (slotId: any) => void;
    productGroupId?: number;
    productGroups?: MappedProductGroup[];
    numberOfProductGroupsInScope: number;
}

export const ProductGroupStatisticsWithActions = ({
    usageStatistics,
    libraryManagedSlotNumber,
    moveDown,
    moveUp,
    productGroupId,
    numberOfProductGroupsInScope
}: Props) => {
    const { t } = useTranslation();
    const moveDownButton = (
        <ButtonIconTextWidthAuto
            onClick={() => moveDown(libraryManagedSlotNumber)}
            icon={MATERIAL_ICON_ARROW_DOWN}
            disabled={libraryManagedSlotNumber === numberOfProductGroupsInScope - 1}
        >
            {t('marketing.productGroups.moveDown')}
        </ButtonIconTextWidthAuto>
    );
    const moveUpButton = (
        <ButtonIconTextWidthAuto
            onClick={() => moveUp(libraryManagedSlotNumber)}
            icon={MATERIAL_ICON_ARROW_UP}
            disabled={libraryManagedSlotNumber === 0}
        >
            {t('marketing.productGroups.moveUp')}
        </ButtonIconTextWidthAuto>
    );

    const editProductGroupLink = (
        <Link to={`${productGroupId}`}>
            <ButtonIconTextWidthAuto onClick={() => {}} theme={BUTTON_THEME_FULL_GREEN} icon={MATERIAL_ICON_EDIT}>
                {t('marketing.productGroups.editProductGroup')}
            </ButtonIconTextWidthAuto>
        </Link>
    );

    if (numberOfProductGroupsInScope < 2) {
        return (
            <StStatisticsWithActions>
                <ProductGroupStatistics usageStatistics={usageStatistics} />
                {editProductGroupLink}
            </StStatisticsWithActions>
        );
    }

    return (
        <StStatisticsWithActions>
            <ProductGroupStatistics usageStatistics={usageStatistics} />
            {editProductGroupLink}
            {moveDownButton}
            {moveUpButton}
        </StStatisticsWithActions>
    );
};
